import { useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { RootState } from '@/store/storeTTS';
import { useDeviceState, useVisionMode } from '@/libTTS/useCommon';
import RtcClient from '@/libTTS/RtcClient';

import styles from './index.module.less';
import CameraCloseNoteSVG from '@/assets/img/CameraCloseNote.svg';
import Utils from '@/utils/utilsTTS/utils';
const LocalVideoID = 'local-video-player';
const LocalScreenID = 'local-screen-player';

function CameraArea(props: React.HTMLAttributes<HTMLDivElement> & { forceShow?: boolean }) {
  const { className, forceShow = false,style, ...rest } = props;
  const room = useSelector((state: RootState) => state.room);
  const { isVisionMode } = useVisionMode();
  // 修改：使用 useVisionMode 中的 isScreenMode
  const { isScreenMode } = useVisionMode();
  const { isVideoPublished, isScreenPublished, switchCamera, switchScreenCapture } =
    useDeviceState();

  const setVideoPlayer = () => {
    if ((isVisionMode || forceShow) && (isVideoPublished || isScreenPublished)) {
      console.log('Setting video player:', { isVisionMode, forceShow, isVideoPublished, isScreenPublished, isScreenMode });
      const useScreenPlayer = isScreenPublished;
      try {
        RtcClient.setLocalVideoPlayer(
          room.localUser.username!,
          isScreenMode ? LocalScreenID : LocalVideoID,
          useScreenPlayer
        );
      } catch (error) {
        console.error('Error setting local video player:', error);
      }
    }
  };
  // 添加：确保视频流正确设置
  useEffect(() => {
    setVideoPlayer();
  }, [isVideoPublished, isScreenPublished, isScreenMode, forceShow]);

  const shouldShow = forceShow || isVisionMode;

  return shouldShow ? (
    <div className={`${styles['camera-wrapper']} ${className}`} {...rest}>
      <div
        id={LocalVideoID}
        className={`${styles['camera-player']} ${isVideoPublished && !isScreenMode ? '' : styles['camera-player-hidden']
          }`}
      />
      <div
        id={LocalScreenID}
        className={`${styles['camera-player']} ${isScreenPublished && isScreenMode ? '' : styles['camera-player-hidden']
          }`}
      />
      <div
        className={`${styles['camera-placeholder']} ${isVideoPublished || isScreenPublished ? styles['camera-player-hidden'] : ''
          }`}
      >
      </div>
    </div>
  ) : null;
}

export default CameraArea;